var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 9C1.25 5.82445 3.82445 3.25 7 3.25C7.41421 3.25 7.75 3.58579 7.75 4V8.25H12C12.4142 8.25 12.75 8.58579 12.75 9C12.75 12.1755 10.1755 14.75 7 14.75C3.82445 14.75 1.25 12.1755 1.25 9ZM6.25 4.81597C4.26055 5.17023 2.75 6.90879 2.75 9C2.75 11.3471 4.65288 13.25 7 13.25C9.09121 13.25 10.8298 11.7394 11.184 9.75H7C6.58579 9.75 6.25 9.41421 6.25 9V4.81597Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5835 2C8.5835 1.58579 8.91928 1.25 9.3335 1.25C12.325 1.25 14.7502 3.67512 14.7502 6.66667C14.7502 7.08088 14.4144 7.41667 14.0002 7.41667H9.3335C8.91928 7.41667 8.5835 7.08088 8.5835 6.66667V2ZM10.0835 2.82173V5.91667H13.1784C12.8756 4.35507 11.6451 3.12456 10.0835 2.82173Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPieChart);
export default __webpack_public_path__ + "static/media/icon-pie-chart.4fe41633268d3ad2b88afffb34c52646.svg";
export { ForwardRef as ReactComponent };